import { footerContainerStyles } from "@insite/content-library/Widgets/Footer/FooterContainer";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerContainerStyles.widgetGridContainer = {
    css: css`
        background-color:  ${getColor("primary")};
        width: 100%;
        margin: 0 auto;
                  
        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                    max-width: ${maxWidths[1]}px;
                    padding: 15px;
                  
                `,
                css`
                    max-width: ${maxWidths[1]}px;  
                    padding: 15px;                                    
                `,
                css`
                    max-width: ${maxWidths[2]}px;   
                    padding: 15px;                
                `,
                css`
                    max-width: ${maxWidths[3]}px;  
                    height: 122px ;
                    display: flex; 
                    padding: 15px;                              
                `,
                css`
                    max-width: ${maxWidths[4]}px;    
                    height: 122px ;
                    display: flex;               
                `,
            ]);
        }}

        > div {
            margin: 0;
        }
    `,
};

footerContainerStyles.logoGridItem = {
    width: 0,
    css: css`
        display: none;
    `,
};

footerContainerStyles.linkList1GridItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
    align-items: center;
    font-size: 1.125rem;
    font-weight: 700;
    padding: 0; 
    `,
};

footerContainerStyles.linkList2GridItem = {
    width: [12, 12, 12, 10, 10],
    css: css`
    align-items: center;
    padding: 0;
    .list-wrapper {
        display: flex;

        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                    justify-content: flex-start;   
                    flex-direction: column;    
                    align-items: flex-start;              
                `,
                css`
                    justify-content: flex-start;    
                    flex-direction: column;    
                    align-items: flex-start;                                
                `,
                css`
                    justify-content: flex-start;    
                `,
                css`                   
                    justify-content: flex-end;              
                `,
                css`                  
                    justify-content: flex-end;
        
                `,
            ]);
        }}
    }
   
    .title-wrapper {
        display: none;
    }
    .list-link > span {
        color: #FFFFFF!important;
        margin-right:30px;
        a {
            color: #FFFFFF!important;
        }
    }
    .list-link > span {
        color: white;       
        font-weight: 400;
        line-height: 32px;
        text-transform: Capitalize;     

        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                    font-size: 1.125rem;              
                `,
                css`
                     font-size: 1.125rem;                                  
                `,
                css`
                     font-size: 1.25rem;    
                `,
                css`                   
                    font-size: 1.25rem;                
                `,
                css`                  
                    font-size: 1.25rem;    
        
                `,
            ]);
        }}
    }
    `,
};

footerContainerStyles.linkList3GridItem = {
    width: 0,
    css: css`   
    `,
};

footerContainerStyles.linkList4GridItem = {
    width: 0,
    css: css`
    `,
};

footerContainerStyles.subscribeGridItem = {
    width: 0,    
    css: css`
        align-items: center;
        padding: 0;
        .title-wrapper {
            display: none;
        }
        .list-link > span {
            color: #FFFFFF!important;

            a {
                color: #FFFFFF!important;
            }
        }       
    `,
};

footerContainerStyles.logoWrapper = {
    css: css`
        display: none;
    `,
}

footerContainerStyles.richContentGridItem = {
    css: css`
        display: none;
    `,
}

footerContainerStyles.siteMapLinksGridItem = {
    css: css`
        display: none;
    `,
}

footerContainerStyles.socialLinksGridItem = {
    css: css`
        display: none;
    `,
}